import Severity from 'features/POSRegisters/interfaces/Severity';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';

export enum AlertType {
  DIAGNOSTIC_ALERT = 'DiagnosticAlert',
  SCAN_FAILURE_ALERT = 'ScanFailureAlert',
  ORPHAN_DEVICE_ALERT = 'OrphanDeviceAlert',
  CONFIGURATION_ALERT = 'ConfigurationAlert',
}

export enum AlertScanSubType {
  CONNECTIVITY = 'Connectivity',
  CHECK_IN_STATUS = 'CheckInStatus',
  NPOS = 'Npos',
  OPERATING_SYSTEM = 'OperatingSystem',
  HARDWARE = 'Hardware',
}

interface AlertBase {
  alertDefinitionId: string;
  deviceType: DeviceType;
  alertType: AlertType;
  scanType?: string;
  scanSubType?: AlertScanSubType;
  siteImpact: Severity;
  shortDescription: string;
  description: string;
  priority?: number;
}

export interface DiagnosticAlert extends AlertBase {
  effect: string;
  solution: string;
  kb: string;
}

export interface AnomalyAlert extends AlertBase {
  effect?: string;
  solution?: string;
  kb?: string;
}

type Alert = DiagnosticAlert | AnomalyAlert;

export default Alert;
